module.exports = __webpack_public_path__ + "static/media/18_get_a.d80daf7e.ogg";